import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=bddb4daa&"
import script from "./Playlist.vue?vue&type=script&lang=ts&"
export * from "./Playlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports